import { useState } from "react";
import { api, formatApiErrorDetail } from "../../../lib/api";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { toast } from "sonner";
import { Section, Field, StatusBadge, fmtUsd, fmtDate, EmptyRow } from "./shared";

const TYPE_LABEL = {
    deposit: "Yatırım", topup: "Yatırım", manual_topup: "Manuel bakiye", admin_adjustment: "Admin +/-",
    ad_account_topup: "Hesap yüklemesi", refund: "İade", cashback: "Cashback", cashback_payout: "Cashback ödemesi",
};

export function UserTransactionsTab({ transactions }) {
    return (
        <Section title={`İşlem geçmişi (${transactions.length})`} subtitle="Cüzdan defteri — son 200 kayıt." testid="user-transactions">
            <div className="overflow-x-auto -mx-5">
                <table className="w-full text-sm min-w-[680px]">
                    <thead className="text-[11px] font-mono uppercase tracking-wider text-muted-foreground">
                        <tr><th className="text-left px-5 py-2">Tarih</th><th className="text-left py-2">Tip</th><th className="text-right py-2">Tutar</th><th className="text-left py-2 pl-4">Durum</th><th className="text-left py-2 pl-4">Not</th></tr>
                    </thead>
                    <tbody className="divide-y divide-white/5">
                        {transactions.length === 0 && <EmptyRow colSpan={5} text="İşlem yok." />}
                        {transactions.map((t) => (
                            <tr key={t.id} data-testid={`tx-row-${t.id}`}>
                                <td className="px-5 py-2 text-xs text-muted-foreground whitespace-nowrap">{fmtDate(t.created_at)}</td>
                                <td className="py-2 text-xs">{TYPE_LABEL[t.type] || t.type}</td>
                                <td className={`py-2 text-right font-mono font-semibold ${t.amount < 0 ? "text-red-300" : "text-emerald-300"}`}>{t.amount < 0 ? "−" : "+"}{fmtUsd(Math.abs(t.amount))}</td>
                                <td className="py-2 pl-4"><StatusBadge value={t.status} /></td>
                                <td className="py-2 pl-4 pr-5 text-xs text-muted-foreground max-w-[320px] truncate" title={t.note || ""}>{t.note || (t.tx_hash ? `${t.tx_hash.slice(0, 14)}…` : "—")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Section>
    );
}

export function UserSecurityCard({ user }) {
    const [pw, setPw] = useState("");
    const [loading, setLoading] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post(`/admin/users/${user.id}/set-password`, { password: pw });
            toast.success("Yeni şifre kaydedildi");
            setPw("");
        } catch (err) {
            toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Şifre güncellenemedi");
        } finally {
            setLoading(false);
        }
    };
    return (
        <Section title="Güvenlik" subtitle="Kullanıcının giriş şifresini sıfırlayın (min. 8 karakter). Yeni şifreyi kullanıcıya güvenli kanaldan iletin." testid="user-security">
            <form onSubmit={submit} className="grid md:grid-cols-[1fr_auto] gap-3 items-end" data-testid="set-password-form">
                <Field label="Yeni şifre"><Input type="text" minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" placeholder="En az 8 karakter" className="bg-background border-white/10 h-9 font-mono" required /></Field>
                <Button type="submit" disabled={loading || pw.length < 8} data-testid="set-password-submit" variant="outline" className="border-primary/40 text-primary hover:bg-primary/10 h-9">{loading ? "…" : "Şifreyi değiştir"}</Button>
            </form>
        </Section>
    );
}

export function UserNotificationsList({ notifications }) {
    return (
        <Section title={`Bildirimler (${notifications.length})`} subtitle="Kullanıcının panelde gördüğü son bildirimler." testid="user-notifications">
            <ul className="divide-y divide-white/5">
                {notifications.length === 0 && <li className="py-6 text-center text-sm text-muted-foreground">Bildirim yok.</li>}
                {notifications.map((n) => (
                    <li key={n.id} className="py-2.5 flex items-start gap-3" data-testid={`notif-row-${n.id}`}>
                        <span className={`mt-1.5 w-1.5 h-1.5 rounded-full shrink-0 ${n.read ? "bg-white/20" : "bg-primary"}`} />
                        <div className="min-w-0">
                            <p className="text-sm font-medium">{n.title}</p>
                            <p className="text-xs text-muted-foreground">{n.body}</p>
                        </div>
                        <span className="ml-auto text-[11px] text-muted-foreground whitespace-nowrap">{fmtDate(n.created_at)}</span>
                    </li>
                ))}
            </ul>
        </Section>
    );
}
